import { formatNumberWithCommas } from "./format-commas";

export const handleTooltipFormatting = (
  params: Record<string, any>,
  prefix?: unknown,
  suffix?: unknown,
) => `
    ${params.seriesName} <br>
    ${params.marker} ${params?.name}: ${handleLabelFormatting(params, prefix, suffix)}
  `;
export const handleLabelFormatting = (
  params: Record<string, string | number>,
  prefix?: unknown,
  suffix?: unknown,
) => `${prefix || ""}${formatNumberWithCommas(params.value)}${suffix || ""}`;
